module.exports = __webpack_public_path__ + "img/ch21_04_摩天轮.70559399.jpg";